import { CREATE_PORTAL } from '@/data/actions/modules/general';
import Main from './components/Main.vue';

export default [
  {
    path: '/settings/portal',
    component: Main,
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: CREATE_PORTAL,
    },
  },
];
